export enum GiveawayStatus {
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'ACTIVE',
  TO_CLOSE = 'TO_CLOSE',
  CLOSED = 'CLOSED',
}
